import {
  DatabaseFieldType,
  type DatabaseField,
  type DatabaseValue
} from '@databases/types/database';
import { type DatabaseChange } from '@databases/utils/database/changesets';
import { type Dispatch, type SetStateAction } from 'react';
import { type IntlShape } from 'react-intl-next';

import {
  type DefaultValueMode,
  type DefaultValueModeSelectConfig
} from './shared/DefaultValueModeSelect';
import { getUserDefaultValueModeSelectConfig } from './user/UserDefaultValueModeSelectConfig';

type DefaultValueModeSelectConfigArgs = {
  addChangeToDraft: (change: DatabaseChange) => void;
  effectiveDefaultValue: DatabaseValue;
  field: DatabaseField;
  formatMessage: IntlShape['formatMessage'];
  optimisticDefaultValueMode: DefaultValueMode | null;
  setOptimisticDefaultValue: Dispatch<SetStateAction<DatabaseValue | null>>;
  setOptimisticDefaultValueMode: Dispatch<SetStateAction<DefaultValueMode | null>>;
};

export const getDefaultValueModeSelectConfig = ({
  addChangeToDraft,
  effectiveDefaultValue,
  field,
  formatMessage,
  optimisticDefaultValueMode,
  setOptimisticDefaultValue,
  setOptimisticDefaultValueMode
}: DefaultValueModeSelectConfigArgs): DefaultValueModeSelectConfig | null => {
  switch (field.type) {
    case DatabaseFieldType.USER:
      return getUserDefaultValueModeSelectConfig({
        addChangeToDraft,
        effectiveDefaultValue,
        field: field as DatabaseField<DatabaseFieldType.USER>,
        formatMessage,
        optimisticDefaultValueMode,
        setOptimisticDefaultValue,
        setOptimisticDefaultValueMode
      });

    default:
      return null;
  }
};
